/**
 * 学生信息完整度计算
 * 与后端 intent-detector.js 的 calculateCompletionRate 保持一致
 */
import type { StudentInfo } from '@/api/chat';

/** 解析可能为 JSON 字符串的数组字段 */
function parseArrayField(value: string | string[] | undefined): string[] {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** 计算学生信息完整度 (0-1) */
export function calculateCompletionRate(info: StudentInfo): number {
  // 必需字段权重：60%
  const requiredChecks = [
    !!info.name,
    !!info.school,
    !!info.grade,
    !!info.stream,
    !!info.totalScore,
  ];
  const requiredScore = requiredChecks.filter(Boolean).length / requiredChecks.length * 0.6;

  // 可选字段权重：20%
  const targetCities = parseArrayField(info.targetCities);
  const majorPreferences = parseArrayField(info.preferredMajors);
  const schoolTierPrefs = parseArrayField(info.schoolTierPreferences);
  const optionalChecks = [targetCities.length > 0, majorPreferences.length > 0, schoolTierPrefs.length > 0];
  const optionalScore = optionalChecks.filter(Boolean).length / optionalChecks.length * 0.2;

  // 基础分：20%
  const baseScore = 0.2;

  return Math.min(1, requiredScore + optionalScore + baseScore);
}
